import { ICrudLocale } from '@app/i18n/interface';

export const CUSTOMER_MANAGEMENT_LOCALE_EN: ICrudLocale = {
  CUSTOMER: {
    LABEL: {
      SINGULAR: 'Customer',
      PLURAL: 'Customers',
    },
    FIELD: {
      NAME: 'Name',
      CUSTOMER: 'Customer',
      EMAIL: 'Email',
      EMAIL_VERIFIED: 'Verification',
      ENABLED: 'Access',
      MOBILE: 'Phone',
      GENDER: 'Gender',
      CREATED_AT: 'Registered',
      LAST_LOGIN: 'Last login',
    },
    LIST: {
      TITLE: 'All customers',
      DESCRIPTION:
        'People with an account on the website. An unverified customer has not confirmed their email yet. Back office staff are under Users.',
      FILTERS: 'Filters',
      FILTERS_ARIA: 'Filter customers',
      SEARCH: 'Search',
      SEARCH_PLACEHOLDER: 'Name or email',
      SEARCH_HINT: 'To search by email, include the @.',
      STATE_ALL: 'All customers',
      STATE_ACTIVE: 'With access',
      STATE_INACTIVE: 'Disabled',
      APPLY: 'Apply filters',
      CLEAR: 'Clear',
      CAPTION: 'Customers registered on the website',
      NEVER: 'Never',
      VIEW_ARIA: 'View {{name}}',
      NO_NAME: 'No name',
      EMPTY: 'No customers registered yet. This lists people who sign up on the website; staff are managed under Users.',
    },
    VERIFIED: {
      YES: 'Verified',
      NO: 'Unverified',
    },
    ENABLED_STATE: {
      ACTIVE: 'With access',
      INACTIVE: 'Disabled',
    },
    DETAIL: {
      TITLE: 'Customer detail',
      SUMMARY: 'Customer data',
      BACK: 'Back to Customers',
      NOT_FOUND: 'The requested customer was not found.',
    },
    BOOKINGS: {
      TITLE: 'Customer bookings',
      DESCRIPTION: 'Orders placed by this customer.',
      EMPTY: 'This customer has no bookings.',
      VIEW: 'View booking',
      VIEW_ARIA: 'View booking {{ref}}',
    },
  },
};
